import { render, staticRenderFns } from "./TBPagination.vue?vue&type=template&id=d825e084&scoped=true"
import script from "./TBPagination.vue?vue&type=script&lang=js"
export * from "./TBPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d825e084",
  null
  
)

export default component.exports